import React from 'react';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useRouter } from 'next/router';
import styled from 'styled-components';

function SearchBar({ cities }) {
  const router = useRouter();
  const citiesWithSlug = cities.map((city) => ({
    name: city.fields.name,
    slug: city.fields.slug,
  }));

  const handleChange = (event, newValue) => {
    router.push(`/catering-${newValue.slug}`);
  };

  return (
    <>
      <Autocomplete
        onChange={handleChange}
        options={citiesWithSlug}
        getOptionLabel={(option) => option.name?.toString()}
        renderInput={(params) => (
          <StyledTextField
            {...params}
            color="primary"
            margin="dense"
            variant="outlined"
            placeholder="Search"
            InputProps={{
              ...params.InputProps,
              startAdornment: <StyledSearchIcon />,
              endAdornment: null,
            }}
          />
        )}
        style={{ width: 300 }}
      />
    </>
  );
}

const StyledSearchIcon = styled(SearchIcon)`
  padding-left: ${(props) => props.theme.spacing(1)}px;
  color: #9e9e9e;
`;

const StyledTextField = styled(TextField)`
  .MuiInputBase-root {
    border-radius: ${(props) => props.theme.spacing(3.5)}px;
  }
`;

export default SearchBar;
